import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import AuthContext from './AuthContext'
import { getToken } from './index'
import Loader from '../components/UI/Loader/Loader'

// eslint-disable-next-line react/prop-types
const ProtectedRoute = ({ children, accessBy }) => {
  const { user, loading } = useContext(AuthContext)

  if (loading) {
    return <Loader />
  }

  if (accessBy === 'non-authenticated') {
    if (!user) {
      return children
    }
  } else if (accessBy === 'authenticated') {
    if (user) {
      return children
    }
  }
  const token = getToken()
  let path = '/login'
  if (token || user) {
    path = '/dashboard'
  }

  return <Navigate to={path}></Navigate>
}

export default ProtectedRoute
